import { oneLineTrim } from 'common-tags';

var _taggedTemplateLiteral = (function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
});

var _templateObject = _taggedTemplateLiteral(['^(([^<>()\\[\\]\\.,;:\\s@"]+(\\.[^<>()\\[\\]\n    \\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]\n    {1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'], ['^(([^<>()\\\\[\\\\]\\\\\\.,;:\\\\s@"]+(\\\\.[^<>()\\\\[\\\\]\n    \\\\\\.,;:\\\\s@"]+)*)|(".+"))@((\\\\[[0-9]{1,3}\\\\.[0-9]{1,3}\\\\.[0-9]{1,3}\\\\.[0-9]\n    {1,3}])|(([a-zA-Z\\\\-0-9]+\\\\.)+[a-zA-Z]{2,}))$']);

function isValidEmail(email) {
  // TODO: Check unit test as the regex has failed to catch no TLD domains.
  var re = new RegExp(oneLineTrim(_templateObject));
  return re.test(email);
}

var emailInputEl = document.getElementById('email-input');
var ctaFormEl = document.getElementById('cta-form');
var convincerCtaEl = document.getElementById('hireme-convincer-cta');

function showPrefilledSignup() {
  window.webappCompatModals.open('LoginSignupModal', {
    inputs: {
      emailAddress: emailInputEl.value,
      form: 'signup',
      skipSuccessRedirectView: true
    },
    size: 'xsmall',
    edgeToEdge: true,
    closeable: true,
    mobileFullscreen: true
  }, function (user) {
    if (user) {
      if (user.successStatus === 'signup_employer') {
        window.location = '/post-project?onboard=true';
      } else if (user.successStatus === 'signup_freelancer') {
        window.location = '/no-commission/additional-info?new_signup=true';
      } else {
        // for successful login
        window.location = '/hireme-widget-builder';
      }
    }
  });
}

if (emailInputEl) {
  emailInputEl.addEventListener('blur', function () {
    var email = emailInputEl.value;
    if (isValidEmail(email)) {
      _t.push(['user_action', {
        section: 'HireMePage',
        label: 'EmailCapture',
        action: 'blur',
        email: email
      }]);
    }
  });
}

if (ctaFormEl) {
  ctaFormEl.addEventListener('submit', function (e) {
    e.preventDefault();
    showPrefilledSignup();
  });
}

if (convincerCtaEl) {
  convincerCtaEl.addEventListener('click', function () {
    return showPrefilledSignup();
  });
}
